import { useReactiveVar } from '@apollo/client';
import type { Serializable } from '@frameio/utils';
import type { ReactiveState } from './ReactiveState';

/** provides updates to components when a particular reactive state value changes */
export const useReactiveState = <T extends Serializable = Serializable>(
  state: ReactiveState<T>
) => {
  return useReactiveVar(state.getVar());
};
